import './style.sass';

import parse from 'html-react-parser';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import AboutUs from '../about-us';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';

const upgreatResultsList = [
    'Работающая платформа, не&nbsp;имеющая аналогов в&nbsp;мире;',
    'Уникальная база датасетов с&nbsp;размеченными файлами;',
    'Более 200 пользователей-участников;',
    '9&nbsp;команд, прошедших квалификацию;',
    '500 минут бесперебойной работы платформы в&nbsp;день финальных испытаний;',
    '8&nbsp;000&nbsp;файлов, обработанных в&nbsp;ходе финалов по&nbsp;русской и&nbsp;английской грамматике;',
    'Есть победители в&nbsp;номинациях по&nbsp;русской и&nbsp;английской грамматике.',
];

const upgreatResultsLinks = [
    {
        img: '/images/svg/upgreat/icon-link.svg',
        link: 'https://vc.ru/promo/183456-everyone-makes-mistakes',
        text: 'Обработка естественного языка: как создать &laquo;грамотного робота&raquo;',
    },
    {
        img: '/images/svg/upgreat/icon-link.svg',
        link: 'https://vc.ru/promo/185328-just-a-family-hobby',
        text: '&laquo;Наш алгоритм вырос из&nbsp;задачки на&nbsp;онлайн-курсе&raquo;: как семейная пара из&nbsp;Уфы создаёт робота-учителя',
    },
];

const Results = () => {
    return (
        <>
            <ScrollAnimation
                className="upgreat-results"
                animateIn="fadeIn"
                offset={100}
                animateOnce={true}
                duration={1}
            >
                <FullWrapper
                    className="upgreat-results__content"
                    smallPaddings={true}
                    caseName="letovo-results"
                >
                    <CommonTitle>Результаты</CommonTitle>
                    <div className="upgreat-results__content">
                        <div className="upgreat-results__list">
                            {upgreatResultsList.map(text => (
                                <div key={text} className="upgreat-results__list-item">
                                    {parse(text)}
                                </div>
                            ))}
                        </div>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
            <ScrollAnimation
                className="upgreat-results__content"
                animateIn="fadeIn"
                offset={100}
                animateOnce={true}
                duration={1}
            >
                <AboutUs />
                <FullWrapper smallPaddings={true}>
                    <CommonSmallTitle>
                        Узнать подробнее о&nbsp;командах-участниках и&nbsp;победителях:{' '}
                    </CommonSmallTitle>
                    {upgreatResultsLinks.map(({ img, link, text }, index) => (
                        <a
                            key={index}
                            className="upgreat-results__link"
                            href={link}
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                        >
                            <img
                                className="upgreat-results__icon"
                                src={img}
                                alt=""
                                aria-hidden="true"
                                loading="lazy"
                            />
                            {parse(text)}
                        </a>
                    ))}
                </FullWrapper>
            </ScrollAnimation>
        </>
    );
};

export default Results;
